import { Component, ChangeDetectionStrategy, inject, effect } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './api/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet />`,
  styles: [`:host { display: block; height: 100vh; }`],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private readonly theme = inject(ThemeService);

  constructor() {
    // Applied to <html> so it covers the login screen too, not just the authenticated shell.
    effect(() => {
      document.documentElement.setAttribute('data-theme', this.theme.isDark() ? 'dark' : 'light');
    });
  }
}
